import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@saucelabs/ds-typography/lib';
import amexCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-amex.png';
import dinersCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-diners.png';
import discoverCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-discover.png';
import jcbCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-jcb.png';
import mastercardCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-mastercard.png';
import visaCardIcon from '@saucelabs/sl-icons/lib/icn-credit-card-visa.png';
import { LinkButton } from '@saucelabs/ds-link';

import Styles from './CreditCard.styles';
import { creditCardInfoSelector } from '../../ducks/billing-info/selectors';

const CardImage = ({ cardIcon }) => (
  <img
    alt="Card"
    className="mr-1"
    height={24}
    src={cardIcon}
    width={36}
  />
);

const EditableCreditCardsDetails = ({ readOnlyCard }) => (
  <div className={`flex flex-col ${readOnlyCard !== false ? 'hidden' : 'visible'}`}>
    <Typography
      className="text-high-emphasis font-semibold"
      disableSpacing
      variant="body-large"
    >
      Credit Card
    </Typography>
    <div className="flex flex-row">
      <div className="w-1/2 mr-1">
        <div
          className={`${Styles['credit-card']} border border-solid border-gray-400 rounded`}
          data-recurly="card"
        />
      </div>
      <div className="flex items-stretch w-1/2 ml-1">
        <div className="self-center">
          <CardImage cardIcon={visaCardIcon} />
          <CardImage cardIcon={mastercardCardIcon} />
          <CardImage cardIcon={amexCardIcon} />
          <CardImage cardIcon={discoverCardIcon} />
          <CardImage cardIcon={dinersCardIcon} />
          <CardImage cardIcon={jcbCardIcon} />
        </div>
      </div>
    </div>
  </div>
);

const ReadOnlyCardDetails = ({ handleReplaceCard, readOnlyCard }) => {
  const recurlyCardDetails = useSelector(creditCardInfoSelector);
  const { lastFour, expires } = recurlyCardDetails;
  return (
    <div className={`${readOnlyCard === true ? 'visible' : 'hidden'}`}>
      <Typography
        className="font-semibold text-gray-900"
        disableSpacing
        variant="body-large"
      >
        Card details
      </Typography>
      <Typography
        className="text-gray-700 font-semibold"
        disableSpacing
        variant="body"
      >
        ⬤⬤⬤⬤ ⬤⬤⬤⬤ ⬤⬤⬤⬤
        {' '}
        {lastFour}
      </Typography>
      <Typography
        className="text-gray-700"
        disableSpacing
        variant="body"
      >
        Expires:
        {' '}
        {expires}
      </Typography>
      <LinkButton
        onPress={handleReplaceCard}
        variant="primary"
      >
        Replace Existing Card
      </LinkButton>
    </div>
  );
};

export const CreditCardDetails = ({ readOnlyCard, handleReplaceCard }) => (
  <>
    <ReadOnlyCardDetails
      handleReplaceCard={handleReplaceCard}
      readOnlyCard={readOnlyCard}
    />
    <EditableCreditCardsDetails
      readOnlyCard={readOnlyCard}
    />
  </>
);
